import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalRJCE = ({ toggleFunction, modalState }) => {
  // const modalTitle = 'Reconocimiento a Jefes de Residentes Año 2025 y Entrega de Carta de Egreso Año 2025'
  const titulo = 'Prueba de Salud Mental'
  const formLink = 'https://forms.gle/d3YHgBzjvpiPAGfU9'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container text-justify premio-dem'>
          {/* <img src={img_modal} alt='Apertura del Concurso de Posgrado de Medicina 2024' className='modal-banner mb-4' /> */}

          <h3 className='modal-subtitle continuous mb-2 lh-base'>{titulo}</h3>

          <h2 className='modal-subtitle mb-4'>Residentes Activos</h2>

          <div className='info-group custom mb-0 mt-1 text-center'>
            <div className='span-group mb-2'>
              <span className='fw-semibold'>Fecha: </span>
              <span>14 de julio de 2026</span>
            </div>

            <div className='span-group mb-2'>
              <span className='fw-semibold'>Hora: </span>
              <span>08:00 AM</span>
            </div>

            <div className='span-group spaced-lg'>
              <span className='fw-semibold'>Lugar: </span>
              <span>Edificio Ciencia y Salud, Salón de Usos Múltiples</span>
            </div>
            
            <Button className='link-button spaced-xl' target='blank' as='a' variant='primary' href={formLink}>
              Formulario de Inscripción
            </Button>


            <div className='d-flex flex-column'>
              <span className='fw-semibold'>Dr. Freddy Pachano Arenas</span>
              <span className='fw-semibold mb-3'>Director</span>

              <span className='fw-semibold'>Dr. Cesar Marín Marcano</span>
              <span className='fw-semibold'>Coordinador</span>
            </div>
          </div>


          <div className='info-group w-100 justify-content-start mb-2'>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalRJCE }